import React from 'react'
import { Button, Dropdown, Menu, Tooltip } from 'antd'
import {
  CheckOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined
} from '@ant-design/icons'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import { selectFolderSort, setFolderSort } from '../../../../slices/aiClassify'

const SORT_ITEMS = [
  { key: 'folderName:asc', label: '按文件夹名 升序' },
  { key: 'folderName:desc', label: '按文件夹名 降序' },
  { key: 'photoCount:desc', label: '按照片数 从多到少' },
  { key: 'photoCount:asc', label: '按照片数 从少到多' },
  { key: 'subfolderCount:desc', label: '按子文件夹数 从多到少' },
  { key: 'subfolderCount:asc', label: '按子文件夹数 从少到多' },
  { key: 'updateTime:desc', label: '按更新时间 从近到远' },
  { key: 'updateTime:asc', label: '按更新时间 从远到近' },
  { key: 'ctime:desc', label: '按创建时间 从近到远' },
  { key: 'ctime:asc', label: '按创建时间 从远到近' }
]

interface FolderSortMenuProps {
  className?: string
}

const FolderSortMenu: React.FC<FolderSortMenuProps> = ({ className }) => {
  const dispatch = useAppDispatch()
  const folderSort = useAppSelector(selectFolderSort)
  const currentKey = `${folderSort.key}:${folderSort.order}`
  const SortIcon =
    folderSort.order === 'asc' ? SortAscendingOutlined : SortDescendingOutlined

  const overlay = (
    <Menu
      selectedKeys={[currentKey]}
      onClick={({ key, domEvent }) => {
        domEvent.stopPropagation()
        const [k, o] = String(key).split(':')
        dispatch(
          setFolderSort({
            key: k as
              | 'folderName'
              | 'photoCount'
              | 'subfolderCount'
              | 'updateTime'
              | 'ctime',
            order: o as 'asc' | 'desc'
          })
        )
      }}
    >
      {SORT_ITEMS.map((item) => (
        <Menu.Item key={item.key}>
          {currentKey === item.key && (
            <CheckOutlined style={{ color: '#6366f1', marginRight: 4 }} />
          )}
          {item.label}
        </Menu.Item>
      ))}
    </Menu>
  )

  return (
    <Dropdown
      popupRender={() => overlay}
      trigger={['click']}
      placement="bottomRight"
    >
      <Tooltip title="排序" placement="bottom">
        <Button className={className} icon={<SortIcon />} aria-label="排序" />
      </Tooltip>
    </Dropdown>
  )
}

export default FolderSortMenu
